"use client";

import { useCallback, useContext, useState } from "react";
import { logEvent } from "@/service/logs/log";
import { ResourceContext } from "@/contexts/resource-context";
import { PictureAsset } from "@/components/common/picture-asset";
import { ArrowRightIcon, XIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SuperLink } from "@/components/common/super-link";
import { createPath } from "@/service/routing/routing";
import { cn } from "@/lib/utils";

export const HomeRoadmapBanner = ({
  closeBanner,
}: {
  closeBanner: () => void;
}) => {
  const { logView } = useContext(ResourceContext);
  const [videosLoaded, setVideosLoaded] = useState(0);
  const bothVideosLoaded = videosLoaded >= 2;
  const handleVideoLoaded = () => setVideosLoaded((n) => n + 1);

  const checkReadyOnMount = useCallback((el: HTMLVideoElement | null) => {
    if (el && el.readyState >= 3) setVideosLoaded((n) => n + 1);
  }, []);

  const handleLinkClick = () => {
    logEvent("home_banner_button_click", logView, {
      banner_type: "roadmap",
    });
  };

  return (
    <div className="relative mb-4 w-full overflow-hidden rounded-2xl sm:h-[212px]">
      <SuperLink
        href={createPath("roadmap.default")}
        onClick={handleLinkClick}
        className="absolute inset-0 z-20"
      />
      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          closeBanner();
        }}
        aria-label="Zamknij baner"
        className="absolute top-4 right-4 z-30 cursor-pointer p-1 text-white transition-colors"
      >
        <XIcon size={20} />
      </button>
      {/* absolute overlay for content */}
      <div className="absolute inset-0 z-10">
        <div className="mt-11 flex h-full flex-col items-center text-center sm:mt-0 sm:justify-center">
          <h2 className="mb-2.5 text-2xl font-bold text-white sm:text-3xl md:text-4xl lg:text-5xl">
            Ścieżki edukacyjne
          </h2>
          <p className="mb-5 text-sm text-white sm:text-base md:text-lg lg:text-xl">
            Odkryj nowy wymiar nauki całkowicie bezpłatnie!
          </p>
          <Button
            variant={"club"}
            className="z-30 rounded-full text-xs sm:text-sm"
          >
            KLIKNIJ I SPRAWDŹ <ArrowRightIcon />
          </Button>
        </div>
      </div>

      <PictureAsset
        source={
          "https://cdn.remedium.md/image/common/2026/04/30/19/roadmap-banner-mobile-bg-png-69f39871d140e"
        }
        ext="png"
        alt="Roadmap"
        className="w-full object-cover sm:hidden"
      />

      <div className="absolute inset-0 hidden bg-black sm:block" />

      <video
        ref={checkReadyOnMount}
        className={cn(
          "absolute top-0 hidden h-full w-auto! opacity-0 transition-opacity duration-700 sm:-left-32 sm:block lg:-left-7",
          bothVideosLoaded && "opacity-100",
        )}
        src="https://cdn.remedium.md/assets/home/roadmap-banner/left.webm"
        autoPlay
        muted
        loop
        playsInline
        onCanPlay={handleVideoLoaded}
      />
      <video
        ref={checkReadyOnMount}
        className={cn(
          "absolute top-0 hidden h-full w-auto! opacity-0 transition-opacity duration-700 sm:-right-32 sm:block lg:-right-7",
          bothVideosLoaded && "opacity-100",
        )}
        src="https://cdn.remedium.md/assets/home/roadmap-banner/right.webm"
        autoPlay
        muted
        loop
        playsInline
        onCanPlay={handleVideoLoaded}
      />
    </div>
  );
};
